import { Autocomplete, Divider, Grid, IconButton, TextField, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useState } from 'react';
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import popupStyles from "../../../assets/styles/componentStyles/globalPopupStyles.module.scss"
import styles from "../../../assets/styles/componentStyles/dataconnector.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import Required from '../../utility/required';
import GlobalButton from '../../utility/globalButton/button';
import { createDataConnectorAssignementPayload, DataConnectorAssignment, dataConnectorAssignmentType, dataConnectorList } from '../../../models/axiosModel';
import { useSearchParams } from 'react-router-dom';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { DataConnectorContext, DataConnectorContextpayload } from '../../../context/dataConnectorContext';
import RefreshIcon from '@mui/icons-material/Refresh';
import { filterAutocompleteOptionsWithException, isSystemApi } from '../../../utils/constants';
import { createNewCustomAPIObj, renderCustomAPIOptions } from '../flowBuilder/flowBuilderConstants';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { getVoiceAgentAssignmentUniqueId, isVoiceAgentDataConnectorAssignment } from '../customApi/assignVoiceAgentPopup';
import GlobalTooltip from '../../utility/tooltip/globalTooltip';

interface AssignCustomApiToVoiceAgentPopupProps {
    getAssignedCustomApis: () => void,
    setFlagAssignDataConnectorPopup: React.Dispatch<React.SetStateAction<boolean>>,
}

const AssignCustomApiToVoiceAgentPopup: React.FC<AssignCustomApiToVoiceAgentPopupProps> = (props) => {

    const { getAssignedCustomApis, setFlagAssignDataConnectorPopup } = props;

    const { dataConnectorList, dataConnectorAssignmentType, assignDataConnectorAssignment, getChatbotDataConnectorList } = useContext(DataConnectorContext) as DataConnectorContextpayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [searchParams] = useSearchParams();
    const voiceAgentId = searchParams.get("voice_agent_id") || "";

    const flagMobileScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 600px)');

    const getVoiceAssignmentTypeId = () => {
        return dataConnectorAssignmentType.find(
            (assignment: dataConnectorAssignmentType) => assignment.data_connector_assignment_type_name.toLowerCase() === "voice agent"
        )?.data_connector_assignment_type_id ?? 0;
    }

    const [payload, setPayload] = useState<createDataConnectorAssignementPayload>({
        chatbot_data_connector_id: -1,
        data_connector_assignment_type_id: getVoiceAssignmentTypeId(),
        data_connector_assignment_unique_id: voiceAgentId,
    });

    const isAssignedToCurrentVoiceAgent = (list: dataConnectorList) => {
        return list.data_connector_assignment?.some(
            (assignment: DataConnectorAssignment) =>
                isVoiceAgentDataConnectorAssignment(assignment)
                && getVoiceAgentAssignmentUniqueId(assignment) === voiceAgentId
        );
    }

    const onChangeOfDataConnector = (value: dataConnectorList | null) => {
        if (value && value?.chatbot_data_connector_id == -1 && value?.data_connector_functions?.data_connector_function_name == "Create New Custom API") {
            window.open('/customAPI/createCustomAPI', '_blank')
        } else {
            setPayload((prevState) => ({
                ...prevState,
                chatbot_data_connector_id: value ? value.chatbot_data_connector_id : -1,
                data_connector_assignment_type_id: getVoiceAssignmentTypeId(),
                data_connector_assignment_unique_id: voiceAgentId,
            }));
        }
    }

    const getDataConnectorOptionsForAutoComplete = (): dataConnectorList[] => {
        let arr: dataConnectorList[] = [];
        if (dataConnectorList) {
            arr = dataConnectorList.filter((list: dataConnectorList) => {
                if (isAssignedToCurrentVoiceAgent(list)) {
                    return false;
                }
                if (isSystemApi(list?.chatbot_data_connector_function_path)) {
                    return Boolean(list.flag_allow_voice_agent_assignment);
                }
                return true;
            });
        }
        return [...arr, createNewCustomAPIObj]
    }

    const disabledAssignBtn = () => {
        return payload.chatbot_data_connector_id == -1 || !voiceAgentId;
    }

    const handleAssignBtnClick = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const assignDataConnectorPayload = {
            chatbot_data_connector_id: payload.chatbot_data_connector_id,
            data_connector_assignment_type_id: getVoiceAssignmentTypeId(),
            data_connector_assignment_unique_id: voiceAgentId,
        }
        const res = await assignDataConnectorAssignment(assignDataConnectorPayload);
        if (res.status) {
            showSuccess("Custom API Assigned Successfully")
            getAssignedCustomApis();
        } else {
            handleError(res);
        }
        setFlagAssignDataConnectorPopup(false);
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    const handleCancelBtnClick = () => {
        setPayload({
            chatbot_data_connector_id: -1,
            data_connector_assignment_type_id: getVoiceAssignmentTypeId(),
            data_connector_assignment_unique_id: voiceAgentId,
        });
        setFlagAssignDataConnectorPopup(false);
    }

    const refreshCustomApiList = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await getChatbotDataConnectorList();
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={popupStyles.popupTitleTypography}>Assign Custom API</Typography>
                        </Grid>

                        <Divider className={popupStyles.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={popupStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"} className={globalStyles.relativePosition}>
                                        <Grid item xs={12}>
                                            <Typography className={popupStyles.popupFieldTypography}>Custom API<Required /></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container gap={1.5} flexWrap={"nowrap"}>
                                                <Grid item xs={flagMobileScreen ? 10 : 11}>
                                                    <Autocomplete
                                                        className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                        options={getDataConnectorOptionsForAutoComplete()}
                                                        getOptionLabel={(option: dataConnectorList) =>
                                                            `${option?.function_method_name || "System API"} - ${option?.data_connector_functions?.data_connector_function_name || ""}`
                                                        }
                                                        value={dataConnectorList?.find((list: dataConnectorList) => list.chatbot_data_connector_id == payload.chatbot_data_connector_id) || null}
                                                        onChange={(_, value: dataConnectorList | null) => onChangeOfDataConnector(value)}
                                                        ListboxProps={{ className: contactStyles.singleContactListbox }}
                                                        filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "data_connector_functions?.data_connector_function_name", "chatbot_data_connector_id")}
                                                        renderOption={(props, option) => renderCustomAPIOptions(props, option)}
                                                        renderInput={(params) => <TextField {...params} placeholder="Select Custom API" />}
                                                    />
                                                </Grid>
                                                <Grid item xs={flagMobileScreen ? 1 : 0.5} className={globalStyles.absolutePosition} right={"10px"} bottom={"1px"}>
                                                    <GlobalTooltip
                                                        title="Fetch latest Custom API"
                                                        placement='top'
                                                        arrow
                                                    >
                                                        <IconButton
                                                            className={contactStyles.headerButtonStyle}
                                                            onClick={() => refreshCustomApiList()}
                                                        >
                                                            <RefreshIcon className={`${styles.primaryColor}`} />
                                                        </IconButton>
                                                    </GlobalTooltip>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} padding={"20px 0"}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => handleCancelBtnClick()}
                                    />
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText={"Assign"}
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle'
                                        disabled={disabledAssignBtn()}
                                        onClick={() => handleAssignBtnClick()}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AssignCustomApiToVoiceAgentPopup
